import { TableHead, TableRow, TableCell } from "@mui/material";
import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";

const AllOffersTableHead = () => {
    const headCells = [
        "Slika",
        "Opis",
        "Status ponude",
        "Cena",
        "Garancija",
        "Vreme isteka",
        ""
    ];

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell, i) => (
                    <TableCell
                        key={i}
                        align="left"
                    >
                        <p style={styles.tableHeadText}>
                            {headCell}
                        </p>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default AllOffersTableHead;

const styles = {
    tableHeadText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "14px",
    },
};
